module.exports = __webpack_public_path__ + "media/SessionStartSoundSuddenAnnouncement.9c7c6278.mp3";